export default "/static/images/base_1.png?0db6152e699df6f7c183a59eb2ad7689";